import { SkuAllOrders } from '@/types/skuDataBackend';
export default async function getSkuOrders(
  slug: string
): Promise<SkuAllOrders> {
  try {
    const response = await fetch(`/api/sku/${slug}/orders`, {
      method: 'GET',
    });

    const skus: SkuAllOrders = await response.json();
    return skus;
  } catch (e) {
    throw new Error('Failed to fetch sku orders');
  }
}
